import Cookies from "js-cookie"
import { html } from "lit-html"
import { virtual, useEffect, useState } from "haunted"
import SegmentedControl from "../filters/segmented-control"
import TypesList from "../filters/types-list"
import DateTime from "../filters/date-time"

const TABS = {
  ATTENDED: "attended",
  REGISTERED: "registered",
  UPCOMING: "upcoming",
}

const TAB_LABELS = {
  [TABS.ATTENDED]: "Attended",
  [TABS.REGISTERED]: "Registered",
  [TABS.UPCOMING]: "Upcoming",
}

const sortTrainings = (trainings, asc = true) => {
  const comparator = asc ? 1 : -1
  trainings.sort((t1, t2) => {
    return t1.date_time.starts_at >= t2.date_time.starts_at
      ? comparator
      : -comparator
  })

  return trainings
}

export const TrainingComponent = virtual(({ endpoint }) => {
  const [loading, setLoading] = useState(true)
  const [attendedList, setAttendedList] = useState([])
  const [registeredList, setRegisteredList] = useState([])
  const [upcomingList, setUpcomingList] = useState([])
  const [activeTab, setActiveTab] = useState(TABS.ATTENDED)
  const csrftoken = Cookies.get("csrftoken")

  const divideTrainingList = (trainings) => {
    const attended = []
    const upcoming = []

    trainings.forEach((training) => {
      if (training.date_time.is_upcoming) {
        upcoming.push(training)
      }
      if (training.checked_in) {
        attended.push(training)
      }
    })

    setAttendedList(sortTrainings(attended, false))
    setRegisteredList(sortTrainings([...trainings], false))
    setUpcomingList(sortTrainings(upcoming, true))
  }

  const loadTraining = () => {
    fetch(endpoint, {
      method: "GET",
      credentials: "include",
      headers: {
        "X-CSRFToken": csrftoken,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        divideTrainingList(res)
        setLoading(false)
      })
      .catch((err) => console.error(err))
  }

  useEffect(loadTraining, [])

  const TrainingRow = ({
    id,
    name,
    url,
    program,
    date,
    start_time,
    shortened_timezone,
    types,
  }) => {
    return html`
      <div
        id="training-${id}"
        class="training-row flex flex-row flex-wrap py-5"
      >
        <div class="w-full md:w-1/2 mb-5 lg:mb-0 pr-7">
          <a class="text-blue" href="${url}"> ${name} </a>
          <div class="mt-3">${TypesList(types)}</div>
        </div>
        <div
          class="w-full md:w-1/2 flex flex-row flex-wrap justify-between text-gray-interactive"
        >
          <div class="training-datetime md:w-2/3">
            ${DateTime({ start_date: date, start_time, shortened_timezone })}
          </div>
          <div class="md:w-1/3">${program || "--"}</div>
        </div>
      </div>
    `
  }

  const content = () => {
    const listByTab = {
      [TABS.ATTENDED]: attendedList,
      [TABS.REGISTERED]: registeredList,
      [TABS.UPCOMING]: upcomingList,
    }
    const trainingList = listByTab[activeTab] || attendedList
    if (trainingList.length > 0) {
      return trainingList.map((training) => TrainingRow(training))
    } else {
      return html`
        <div class="mt-12 flex flex-col items-center justify-center h-full">
          No results.
        </div>
      `
    }
  }

  return html`
    <div
      class="mt-7 mb-10 md:mb-14 loader-container ${loading ? "loading" : ""}"
    >
      ${SegmentedControl({
        section: "training-tabs",
        items: Object.values(TABS).map((tab) => ({
          value: tab,
          label: TAB_LABELS[tab],
        })),
        activeValue: activeTab,
        onChange: setActiveTab,
      })}
      ${loading ? "" : content()}
    </div>
  `
})
